<template>
  <nav v-if="isReports()"
       id="sidebar-wrapper"
       class="text-left text-danger font-weight-bolder shadow side-nav"
       style="width: 140px; height: calc(100vh - 147px)"
  >
    <div class="">
      <div class="pt-2 text-center">Report Menu</div>
      <hr class="my-1" />
      <ul class="nav flex-column h-100 text-small">
        <li class="nav-item">
          <router-link :to="{name: 'GenerateIMOCrewList' }"
                       tag="a"
                       class="nav-link text-dark"
                       active-class="active"
                       role="tab"
                       data-toggle="list">
            Regular List IMO
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'IMOHistory' }"
                       tag="a"
                       class="nav-link text-dark"
                       role="tab"
                       active-class="active"
                       data-toggle="list">
            History IMO
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'GenerateWhoIsOnboard' }"
                       tag="a"
                       class="nav-link text-dark"
                       active-class="active"
                       role="tab"
                       data-toggle="list">
            Who's Onboard
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'GenerateStandbyCrewList' }"
                       tag="a"
                       class="nav-link text-dark"
                       active-class="active"
                       role="tab"
                       data-toggle="list">
            Who's Available
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'GenerateAgeAverage' }"
                       tag="a"
                       class="nav-link text-dark"
                       active-class="active"
                       role="tab"
                       data-toggle="list">
            Average Age
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'CovidVaccinatedCrewList' }"
                       tag="a"
                       class="nav-link text-dark"
                       active-class="active"
                       role="tab"
                       data-toggle="list">
            Crew Covid Vaccinated
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'GeneratePandIReports' }"
                       tag="a"
                       class="nav-link text-dark"
                       active-class="active"
                       role="tab"
                       data-toggle="list">
            P&I Reports
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'GenerateLMCVReport' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('LMCVReport')}"
                       role="tab"
                       data-toggle="list">
            LMCV - JP
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'GenerateCabinMonitoring' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('CabinMonitoring')}"
                       role="tab"
                       data-toggle="list">
            Cabin Monitoring
          </router-link>
        </li>
        <li class="nav-item">
          <a
              tag="a"
              class="nav-link text-dark"
              href="#"
              id="JISSReportDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
              @click="togglePerDocumentLi">
            JISS Reports
          </a>
        </li>
        <li class="nav-item" v-if="showPerDocumentLi">
          <router-link
              :to="{ name: 'GeneratePerDocumentMonitoring' }"
              tag="a"
              class="nav-link text-dark"
              :class="{ 'active': isActiveRoute('GeneratePerDocumentMonitoring') }"
              role="tab"
              data-toggle="list"
          >
            <span style="ml-1">- Per Document</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'GenerateDocumentMonitoring' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('GenerateDocumentMonitoring')}"
                       role="tab"
                       data-toggle="list">
            Document Monitoring
          </router-link>
        </li>
        <li>
          <router-link :to="{name: 'CrewAccounts'}"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('CrewAccounts')}"
                       role="tab"
                       data-toggle="list">
            Active Crew Profiling
          </router-link>
        </li>
        <li v-if="!isKline">
          <router-link :to="{name: 'GenerateMmce'}"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('MMCEReport')}"
                       role="tab"
                       data-toggle="list">
            MMCE Report
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { vueAppMixin } from '../../../mixins/vueAppMixin';
import {gateMixin} from "../../../mixins/gateMixin";

export default {
  name: 'ReportSideNav',
  mixins: [vueAppMixin,gateMixin],
  data() {
    return {
      showPerDocumentLi: false,
    };
  },
  methods: {
    togglePerDocumentLi() {
      this.showPerDocumentLi = !this.showPerDocumentLi;
    },
  },
};
</script>


<style scoped>
.nav-link.active, .nav-link:hover {
  background-color: #e87c87;
  color: white !important;
}
</style>
